import { useQuery } from "@tanstack/react-query";
import { supabase } from "../lib/supabase";

// Live categories list. "All" is a synthetic pseudo-category prepended client-side
// so the UI can treat "no filter" uniformly. Ordered by sort_order to match admin.
//
// Cached via TanStack Query — categories rarely change so 10-minute staleTime
// is safe; the "All" pseudo-row is added in the selector so the cached value
// stays a clean DB shape.
const ALL_CAT = { id: "all", name: "All", icon: "✨" };

export function useCategories() {
  const { data, isLoading } = useQuery({
    queryKey: ["categories"],
    staleTime: 10 * 60_000,
    queryFn: async () => {
      const { data, error } = await supabase
        .from("categories")
        .select("id, name, slug, icon, sort_order")
        .order("sort_order", { ascending: true });
      if (error) throw error;
      return data || [];
    },
  });

  return { categories: [ALL_CAT, ...(data || [])], loading: isLoading };
}
